import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { SportEventsNewQueryKeys } from "./sportEventsNewQueryKeys";
import { getTopSportEventsNew } from "@/api/sportEventsNew";
import { SportType } from "@/api/sportEventsNew";
import { FeedType } from "@/types/SportsApiResponses";

interface QueryOptions {
  feedType?: FeedType;
  sportType: SportType;
}

interface Options {
  queryOptions: QueryOptions;
  enabled?: boolean;
}

export const useTopSportEventsNew = (options: Options) => {
  const locale = useLocale();

  return useQuery({
    queryKey: [SportEventsNewQueryKeys.Top, locale, options.queryOptions.feedType, options.queryOptions.sportType],
    refetchInterval: 5000,
    queryFn: async ({ signal }) => {
      const params = { lang: locale, ...options.queryOptions };
      return await getTopSportEventsNew({ params, signal });
    },
  });
};
